module.exports = __webpack_public_path__ + "static/media/close.4618bc82.png";